/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Search_DescInputs */

const en_pc_online_task_search_desc = /** @type {(inputs: Pc_Online_Task_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Find (it is also in the ⌘K command palette) and start typing. Matches highlight as you type; press ⌘G to jump to the next one.`)
};

const zh_pc_online_task_search_desc = /** @type {(inputs: Pc_Online_Task_Search_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 Find（也可以在 ⌘K 命令面板中找到）并开始输入。输入时匹配项会实时高亮，按 ⌘G 跳到下一个。`)
};

/**
* | output |
* | --- |
* | "Open Find (it is also in the ⌘K command palette) and start typing. Matches highlight as you type; press ⌘G to jump to the next one." |
*
* @param {Pc_Online_Task_Search_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_search_desc = /** @type {((inputs?: Pc_Online_Task_Search_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Search_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_search_desc(inputs)
	return zh_pc_online_task_search_desc(inputs)
});
export { pc_online_task_search_desc as "pc.online.task.search.desc" }